import React from 'react'
import * as Icon from 'react-feather'
import { usePaginationContext } from './context'
import Styles from './styles'

export default function Pages() {
  const {
    currentPage,
    handleNextPage,
    handlePaginate,
    handlePrevPage,
    pages,
    totalPages,
  } = usePaginationContext()
  return (
    <Styles.CustomPagination>
      <button disabled={currentPage === 1} onClick={handlePrevPage}>
        <Icon.ChevronLeft
          size="20"
          color={currentPage === 1 ? '#b3b1b1' : '#000'}
        />
      </button>
      <div>
        {pages.map((value, index) => {
          return (
            <button
              style={{
                pointerEvents: value === '...' ? 'none' : 'auto',
              }}
              key={index}
              onClick={() => handlePaginate(value)}
              data-active={value === currentPage}
            >
              {value}
            </button>
          )
        })}
      </div>
      <button disabled={currentPage === totalPages} onClick={handleNextPage}>
        <Icon.ChevronRight
          size="20"
          color={currentPage === totalPages ? '#b3b1b1' : '#000'}
        />
      </button>
    </Styles.CustomPagination>
  )
}
